var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.582 5.99967H20.1654V7.83301H18.332V19.7497C18.332 20.2559 17.9216 20.6663 17.4154 20.6663H4.58203C4.07577 20.6663 3.66536 20.2559 3.66536 19.7497V7.83301H1.83203V5.99967H6.41536V3.24967C6.41536 2.74342 6.82577 2.33301 7.33203 2.33301H14.6654C15.1716 2.33301 15.582 2.74342 15.582 3.24967V5.99967ZM16.4987 7.83301H5.4987V18.833H16.4987V7.83301ZM8.2487 10.583H10.082V16.083H8.2487V10.583ZM11.9154 10.583H13.7487V16.083H11.9154V10.583ZM8.2487 4.16634V5.99967H13.7487V4.16634H8.2487Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.8589ec63ce50cac36a1b39a4cdb807a3.svg";
export { ForwardRef as ReactComponent };